import Box from "@mui/material/Box";
const DashboardSection = ({ customStyle, children }) => {
	return <Box sx={{ ...customStyle }}>{children}</Box>;
};
export default DashboardSection;
